import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ITransfer {
  hasTrains: boolean;
  hasBus: boolean;
  trainPrice: number | undefined;
  isIncluded: boolean;
}

const initialState: ITransfer = {
  hasTrains: false,
  hasBus: false,
  trainPrice: undefined,
  isIncluded: false,
};

const transferDataSlice = createSlice({
  name: 'transferData',
  initialState,
  reducers: {
    setTransfers: (state, action: PayloadAction<ITransfer>) => {
      state.hasTrains = action.payload.hasTrains;
      state.hasBus = action.payload.hasBus;
      state.trainPrice = action.payload.trainPrice;
      state.isIncluded = action.payload.isIncluded;
    },
  },
  extraReducers: (builder) =>
    builder.addCase('resetTransferData', () => {
      return initialState;
    }),
});

export const { setTransfers } = transferDataSlice.actions;

export default transferDataSlice.reducer;
